import React from "react";
import { DAYS_OF_WEEK, MONTHS } from "./constants";

/**
 * DateCard component - Displays date information
 * @param {Date} date - Date to display
 * @param {string} instance - Business day instance
 */
const DateCard = ({ date, instance }) => {
  const getFullDayFromDate = (dateObj) => {
    const dayIndex = dateObj.getUTCDay();
    return DAYS_OF_WEEK[dayIndex];
  };

  const getFullMonthFromDate = (dateObj) => {
    const monthIndex = dateObj.getUTCMonth();
    return MONTHS[monthIndex];
  };

  const dateObj = new Date(date);

  return (
    <div className="flex flex-col justify-center">
      <div className="text-sm">
        <div>
          <div className="flex items-center justify-center gap-1">
            <div className="text-blue-600 text-2xl dark:text-blue-400">
              {getFullMonthFromDate(dateObj)}
            </div>
            <div className="text-2xl">
              {getFullDayFromDate(dateObj)}
            </div>
          </div>
          <div className="text-[56px] my-4 leading-[56px]">
            {dateObj.getUTCDate()}
          </div>
        </div>
        <span className="text-2xl">{instance}</span>
      </div>
    </div>
  );
};

export default DateCard;
